<template>
	<section>
		<!-- 撤销退款成功弹框 -->
		<toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>
		
		<!-- 是否同意和拒绝退款谈开关你-->
		<confirm-modal v-if="isRevoke" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
		    @leftClick="onCloseModalClick" @rightClick="adminOrder">
		</confirm-modal>
		
		<ul class="follow-wrap">
			<samp></samp>
			<li v-for='(item,index) in refundList' :key="index" :class='index!=0?"step-m":""'>
				<div :class='index==0?"step-first":"step-img"'>
					<img v-if='index==0 && (item.content.indexOf("成功")!=-1)'  src="@/assets/images/order-manage/pic_recharge_right2.png" class="final-step"/>
					<img v-else-if='index==0 && (item.content.indexOf("审核")!=-1)' src="@/assets/images/order-manage/pic_more.png" class="final-step"/>
					<div v-else class="step-sec"></div>
				</div>
				<div>
					<p>{{item.content}}</p>
					<span>{{item.create_time}}</span>
				</div>
			</li>
			<div class="samp-b"></div>
		</ul>
		
		<ul class="refund-detail">
			<li>
				<div>退款金额</div>
				<span>￥{{orderInfo.refund_price}}</span>
			</li>
<!--      <li v-if="Object.keys(order_add_info).length >0 ">
        <div>追加费用</div>
        <span>￥{{order_add_info.add_price}}</span>
      </li> -->
			<li>
				<div>退款状态</div>
				<span>{{refund_status | filterRefund}}</span>
			</li>
			<li>
				<div>退款编号</div>
				<span>{{orderInfo.refund_number}}</span>
			</li>
			<li>
				<div>订单编号</div>
				<span>{{orderInfo.order_code}}</span>
			</li>
			<li>
				<div>退回路径</div>
				<span>原路退回</span>
			</li>
			<li>
				<div>发起时间</div>
				<span>{{orderInfo.refund_time}}</span>
			</li>
		</ul>
		
		<div class="btn-wrap">
			<div class="back" @click="backDetail">返回列表</div>
			<div class="refund" @click="operateOrder(6)" v-if='orderInfo.order_status==10 && refund_status == 1 && refund=="user"'>撤销退款，继续处理</div>
			<div v-if='refund=="admin"'>
				<div class="refund btn-b" v-if='orderInfo.order_status==10 && refund_status == 1'	    @click="revoke(11)">拒绝退款</div>
				<div class="refund btn-b agree" v-if='orderInfo.order_status==10 && refund_status == 1' @click="revoke(3)">同意退款</div>
			</div>
		</div>
	</section>
	
</template>
<script>
	import ConfirmModal from '@/components/ConfirmModal'
	import ToastModal from '@/components/ToastModal'
	import {getOrderRefundRecord,operateOrder,adminOrder} from '@/api/order'
	import utils from '@/assets/jslibs/utils'
	export default {
		data(){
			return{
				OrderFollowList:[],
				order_uuid:this.$route.query.order_uuid,
                refund_status:"",    //退款状态
				refundList:[],		//退款记录
				orderInfo:{},		//订单详情
        order_add_info:{},//费用追加详情
				backurl:this.$route.query.backurl,    	//回调地址
				ToastText:"撤销退款成功",
				isToast:false,
				refund:this.$route.query.refund,
				isRevoke:false,			//同意拒绝退款弹框
				firmTitle:"",
				firmLeft:"",
				firmRight:"",
				type:""					//同意还是拒绝退款
			}
		},
		filters: {
			filterRefund(val) {
				switch(Number(val)){
					case 1:
						return "审核中";
						break;
					case 2:
						return "通过";
						break;
					case 3:
						return "拒绝";
						break;
				}
			},
			
			filterPay(val){
				if(val == "微信支付"){
					return "微信钱包"
				}else if(val == "余额支付"){
					return "钱包余额"
				}else{
					return val
				}
			}
		},
		
		beforeCreate(){
			if(this.$route.query.refund && this.$route.query.refund == "user"){
				sessionStorage.setItem("roleType","customer")
			}else{
				sessionStorage.removeItem("roleType");
			}
		},
		
		created() {
			window.scrollTo(0,0);
			this.getOrderRefundRecord();
		},
		
		mounted(){
			document.title = "退款详情";
		},
        
		methods:{
			//查询退款记录
			async getOrderRefundRecord(){
                let obj = {order_uuid:this.order_uuid};
				const { data, status } = await getOrderRefundRecord(obj);
				if (status !== 200) return
				this.refundList = data.data;
				this.orderInfo = data.order_info;
				this.order_add_info = data.order_add_info;
                this.refund_status = this.refundList[0].refund_status
				if(this.orderInfo){
					this.order_uuid = this.orderInfo.uuid
				}
			},
			
			backDetail(){
				if(this.refund == "user"){
					sessionStorage.setItem("peg",2);
					sessionStorage.setItem("stamp","order");
					this.$router.push({path:'./index'})
				}
				else if(this.refund == "admin"){
					this.$router.push({path:'./myorder-admin'});
				}
				
			},
			
			//返回
			back(){
				location.href = this.backurl
			},
			
			//退款弹窗
			revoke(type){
				this.isRevoke = true;
				this.type = type;
				this.firmLeft = "取消";
				this.firmRight = "确认";
				if(type == "3"){//同意退款
					this.firmTitle = "是否同意退款";
					this.ToastText = "同意退款成功";
				}else{
					this.firmTitle = "是否拒绝退款";
					this.ToastText = "拒绝退款成功";
				}
			},
			
			//确定撤销退款
			async operateOrder(type){
				let parmas ={type:type};
				const { data, status } = await operateOrder(this.order_uuid,parmas);
				if (status !== 200) return;
				this.isRevoke = false;
				this.isToast = true;
				this.getOrderRefundRecord()
			},
            
            //确定拒绝还是同意退款
            async adminOrder(type){
            	let parmas ={type:this.type};
            	const { data, status } = await adminOrder(this.order_uuid,parmas);
            	if (status !== 200) return;
            	this.isRevoke = false;
            	this.isToast = true;
            	this.getOrderRefundRecord()
            },
            
			onCloseModalClick(){
				this.isRevoke = false;
			}
		},
		
		components:{
			ToastModal,
			ConfirmModal
		}
	}
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular,PingFang SC;font-weight:400;padding-top: 20px;overflow: hidden;}
	.follow-wrap{margin-left: 18px;margin-bottom: 25px;width: 100%;background: url(../../assets/images/order-manage/point.png) repeat-y 15px;position: relative}
	.follow-wrap li{display: flex;align-items: center;margin-bottom: 38px;}
	.follow-wrap .step-m{margin-left: 7.5px;}
	.follow-wrap li:last-child{margin-bottom: 0px;}
	.follow-wrap li .step-first{width:30px;height:30px;margin-right: 18px;display: flex;align-items: center;justify-content: center;}
	.follow-wrap li .step-img{width:15px;height:15px;background:rgba(216,216,216,0.5);border-radius: 50%;margin-right: 18px;display: flex;align-items: center;justify-content: center;}
	.follow-wrap li img{width:30px;height:30px;}
	.follow-wrap li .step-sec{width: 8.5px;height: 8.5px;border-radius: 50%;background:rgba(216,216,216,1);}
	.follow-wrap li .final-step{width: 30px;height: 30px;}
	.follow-wrap li p{font-size:17px;font-weight:500;color:rgba(51,51,51,1);margin-bottom:2px;}
	.follow-wrap li span{font-size:12px;color:rgba(153,153,153,1);}
	samp{width: 1px;height: 8px;font-size: 0;background-color: #fff;position: absolute;top: 0;left: 4vw;}
	.samp-b{position: absolute;height: 0.468rem;width: 1px;background: #fff;bottom: 0;left: 0.4rem;}
    .refund-detail{margin: 0 15px;border-top: 1px solid #E5E5E5;padding-top: 23px;}
	.refund-detail li{display: flex;align-items: center;justify-content: space-between;margin-bottom: 8px}
	.refund-detail li div{font-size:14px;;color:rgba(153,153,153,1);}
	.refund-detail li span{font-size:14px;color:rgba(51,51,51,1);}
	.btn-wrap{margin-top: 40px;margin-bottom: 70px}
	.btn-wrap .back{width:180px;height:34px;line-height: 34px;margin: 0 auto;margin-bottom: 8px;background:rgba(65,132,244,0.1);border-radius:3px;border:1px solid rgba(65,132,244,0.5);text-align: center;font-size:14px;color:rgba(65,132,244,1);}
	.btn-wrap .refund{width:180px;height:34px;line-height: 34px;margin: 0 auto;background:rgba(102,102,102,0.06);border-radius:3px;border:1px solid rgba(65,132,244,0.5);text-align: center;font-size:14px;color:rgba(51,51,51,1);}
	.btn-wrap .agree{margin: 9px auto}
	.btn-wrap .btn-b{border: 1px solid rgba(193,193,193,1);}
</style>
